module.exports = __webpack_public_path__ + "img/order-step2-c.fe9fe8b5.png";